//#region Imports
import { createFeature, createReducer, on } from '@ngrx/store';
import { EmptyAddress } from 'clicklease-ui-elements';
import {
    LoadBusinessInfoFormAction,
    ResetBusinessInfoFormAction,
    ResetBusinessInfoAddressAction,
    ResetBusinessInfoEmailAction,
    ResetBusinessInfoNameAction,
    ResetBusinessInfoPhoneAction,
    ResetSubmittingBusinessInfoAction,
    SetBusinessInfoFormAction,
    SetBusinessInfoFormAddressAction,
    SetBusinessInfoFormEmailAction,
    SetBusinessInfoFormNameAction,
    SetBusinessInfoFormPhoneAction,
    SetSubmittingBusinessInfoAction,
    SetSubmittingBusinessInfoErrorAction,
} from './business-info-form.actions';
import { BusinessInformationFormState } from './../../interfaces/business-information';

//#region State consts

const initialState: BusinessInformationFormState = {
    isSubmitting: false,
    isSubmittingError: false,
    loading: false,
    data: {
        name: '',
        phone: '',
        email: '',
        address: EmptyAddress(),
    },
};

export const BusinessInfoFormFeatureName = 'BusinessInfoForm';

//#region Feature

export const BusinessInfoFormFeature = createFeature({
    name: BusinessInfoFormFeatureName,
    reducer: createReducer(
        initialState,
        on(LoadBusinessInfoFormAction, (state) => ({
            ...state,
            loading: true,
            isSubmitting: false,
            isSubmittingError: false
        })),
        on(ResetBusinessInfoFormAction, () => initialState),
        on(ResetBusinessInfoAddressAction, (state) => ({
            ...state,
            data: {
                ...state.data,
                address: EmptyAddress(),
            },
        })),
        on(ResetBusinessInfoEmailAction, (state) => ({
            ...state,
            data: {
                ...state.data,
                email: initialState.data.email,
            },
        })),
        on(ResetBusinessInfoNameAction, (state) => ({
            ...state,
            data: {
                ...state.data,
                name: initialState.data.name,
            },
        })),
        on(ResetBusinessInfoPhoneAction, (state) => ({
            ...state,
            data: {
                ...state.data,
                phone: initialState.data.phone,
            },
        })),
        on(ResetSubmittingBusinessInfoAction, (state) => ({
            ...state,
            isSubmitting: false,
        })),
        on(
            SetBusinessInfoFormAction,
            (state, { name, phone, email, address }) => ({
                ...state,
                data: {
                    name,
                    phone,
                    email,
                    address,
                },
            })
        ),
        on(SetBusinessInfoFormNameAction, (state, { name }) => ({
            ...state,
            data: {
                ...state.data,
                name,
            },
        })),
        on(SetBusinessInfoFormPhoneAction, (state, { phone }) => ({
            ...state,
            data: {
                ...state.data,
                phone,
            },
        })),
        on(SetBusinessInfoFormEmailAction, (state, { email }) => ({
            ...state,
            data: {
                ...state.data,
                email,
            },
        })),
        on(SetBusinessInfoFormAddressAction, (state, { address }) => ({
            ...state,
            data: {
                ...state.data,
                address,
            },
        })),
        on(SetSubmittingBusinessInfoAction, (state) => ({
            ...state,
            isSubmitting: true,
            loading: false
        })),
        on(SetSubmittingBusinessInfoErrorAction, (state) => ({
            ...state,
            isSubmittingError: true,
            loading: false
        }))
    ),
});
